import {Row} from "antd";
import SearchCategories from "../SearchCategories";
import "./DisplayBanner.scss";
import {NavLink} from "react-router-dom";
import {env} from "../../env/env";
import {useEffect, useState} from "react";
import ChalklineShort from "../icons/ChalklineShort";
import {useRecoilValue} from "recoil";
import {memberState} from "../../state/atoms";

export default function DisplayBanner() {
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const member = useRecoilValue(memberState);

  const bannerContent = [
    {
      subtitle: "Upgrade your chalkboard to digital",
      chalkSvg: <ChalklineShort/>,
      targetWord: "chalkboard",
      index: 4
    },
    {
      subtitle: "Try a chalk-free customer experience",
      chalkSvg: <ChalklineShort/>,
      svgLeftMargin: 60,
      targetWord: "chalk-free",
      index: 5
    },
    {subtitle: "Automate content on your TVs", index: 1},
    {subtitle: "Save steps creating menu boards", index: 2},
    {subtitle: "Create a memorable customer experience", index: 3},
    {subtitle: "Don't lift a finger for breakfast, lunch, & dinner", index: 6},
    {subtitle: "Save steps creating digital signage", index: 7}
  ];

  useEffect(() => {
    // Get the stored index from localStorage or default to -1
    const storedIndex = parseInt(localStorage.getItem('displayBannerIndex') || '-1');

    // Calculate next index, wrapping around to 0 if we reach the end
    const nextIndex = (storedIndex + 1) % bannerContent.length;

    // Store the new index and update state
    localStorage.setItem('displayBannerIndex', nextIndex.toString());
    setCurrentBannerIndex(nextIndex);
  }, [bannerContent.length]);

  const renderSubtitleWithChalk = (subtitle: string, targetWord: string | undefined, ChalkSvg: React.ReactNode) => {
    if (!targetWord) {
      return <h3>{subtitle}</h3>;
    }

    const parts = subtitle.split(targetWord);
    return (
      <div className="subtitle-container">
        <h3>
          {parts[0]}
          <span className="target-word">
            {targetWord}
            <div className="chalk-svg">
              {ChalkSvg}
            </div>
          </span>
          {parts[1]}
        </h3>
      </div>
    );
  };

  return (
    <Row>
      <div className={`home-banner dsab`}>
        <div className="mobile-search-cats">
          <SearchCategories/>
        </div>

        <div className="dsa-banner">
          <div className="mobile-banner-content">
            <div className="video-container">
              <video
                src={`https://timber.mhmcdn.com/site/marketing/homepage/dashboard/Display%20Boards%20Skykit%20Light%20${bannerContent[currentBannerIndex].index}.mp4`}
                autoPlay loop muted playsInline/>
            </div>

            <div className="icon-title">
              <div className="display-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <path
                    d="M24.8098 9.82965L9.40128 7.55995C9.1934 7.53026 8.98128 7.58965 8.82431 7.72965C8.79037 7.75935 8.75643 7.79329 8.73097 7.83147L6.84734 7.55995C6.63946 7.53026 6.43158 7.59389 6.27461 7.72965C6.24067 7.75935 6.21522 7.78905 6.18976 7.82298L4.2934 7.55995C4.08552 7.53026 3.87764 7.59389 3.72067 7.72965C3.5637 7.86541 3.47461 8.0648 3.47461 8.27268V18.6115C3.47461 18.8024 3.55097 18.989 3.69097 19.1248C3.82673 19.2563 4.00916 19.3327 4.19582 19.3327C4.19582 19.3327 4.20006 19.3327 4.20431 19.3327L6.10067 19.3115C6.13461 19.3836 6.18128 19.4515 6.24067 19.5109C6.37643 19.6424 6.55885 19.7187 6.74552 19.7187C6.74552 19.7187 6.74976 19.7187 6.754 19.7187L8.68006 19.6933C8.70976 19.7442 8.74794 19.7951 8.79037 19.8375C8.92612 19.969 9.10855 20.0454 9.29522 20.0454C9.29522 20.0454 9.29946 20.0454 9.3037 20.0454L24.7122 19.846C25.1067 19.8418 25.4249 19.5193 25.4249 19.1248V10.5424C25.4249 10.186 25.1619 9.88056 24.8098 9.82965ZM6.02006 17.869L4.90855 17.8818V9.09995L6.02006 9.25268V17.869ZM8.574 9.6048V18.2509L7.46249 18.2636V9.09995L8.574 9.25692V9.60056V9.6048ZM23.9867 18.4121L22.8752 18.4248L22.154 18.4333L20.317 18.4587L10.0164 18.5945V9.10844L19.6001 10.5212L20.3213 10.6272L22.154 10.8987L22.8752 11.0048L23.9867 11.1703V18.4163V18.4121Z"
                    fill="white"/>
                  <path
                    d="M16.6266 12.2691C16.5841 12.2224 16.5205 12.2521 16.5205 12.3242V16.1339C16.5205 16.2018 16.5841 16.2484 16.6266 16.2145L19.1466 14.5939C19.1848 14.5642 19.1848 14.4963 19.1466 14.4581L16.6266 12.2691Z"
                    fill="white"/>
                </svg>
              </div>
              <h2>Display</h2>
            </div>
            {renderSubtitleWithChalk(
              bannerContent[currentBannerIndex].subtitle,
              bannerContent[currentBannerIndex].targetWord,
              bannerContent[currentBannerIndex].chalkSvg
            )}
          </div>

          <div className="desktop-only video-container">
            <video
              src={`https://timber.mhmcdn.com/site/marketing/homepage/dashboard/Display%20Boards%20Skykit%20Light%20${bannerContent[currentBannerIndex].index}.mp4`}
              autoPlay loop muted playsInline/>
          </div>

          <div className="desktop-only left-section">
            <div className="dsa-title">
              {renderSubtitleWithChalk(
                bannerContent[currentBannerIndex].subtitle,
                bannerContent[currentBannerIndex].targetWord,
                bannerContent[currentBannerIndex].chalkSvg
              )}
            </div>
          </div>
          <div className="right-section">
            <a className="ant-btn ant-btn-lg" href="/feature/digital-menu-board-solution.html" target="_blank"
               rel="noreferrer">Learn More</a>
            {!member.viewOnly &&
              <NavLink to={`${env.dashboardPath}/dsa/manage`} className="ant-btn ant-btn-lg try-out">Try It
                Out</NavLink>
            }
          </div>
        </div>
      </div>
    </Row>
  );
}
